import { NavLink } from 'react-router-dom'
import { ROUTES } from '../../lib/constants'

const authTabClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? 'text-[#fff] border-b-2 border-[#fff]' : 'text-[#ABA7AF]'

export const AuthTabs = () => (
    <div className='flex gap-5 mb-2 text-[0.938rem]'>
        <NavLink className={authTabClass} to={ROUTES.AUTH.LOGIN}>
            Войти
        </NavLink>
        <NavLink className={authTabClass} to={ROUTES.AUTH.REGISTRATION}>
            Зарегистрироваться
        </NavLink>
    </div>
)
